import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon3dot } from '../../../../assets/icon';
import ButtonTypes from '../../../../constants/buttonTypes';
import ButtonDropdownMenuItem from '../../../../components/ButtonDropdownMenuItem/ButtonDropdownMenuItem';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';
import CustomDropdownMenu from '../../../../components/CustomDropdownMenu/CustomDropdownMenu';

const actionButtonClassName = 'p-0 w-[26px] h-[26px] min-w-[26px] min-h-[26px]';
const actionContainerClassName = 'min-w-[250px]';

const WarehouseActions = ({
  side, onEdit, onDelete, onToOrder, onHistory
}) => {
  const [visible, toggleVisible] = useState(false);
  return (
    <CustomDropdownMenu
      Icon={Icon3dot}
      btnType={ButtonTypes.LIGHT}
      side={side}
      drop="right"
      btnStyle={actionButtonClassName}
      containerStyle={actionContainerClassName}
      visible={visible}
      toggleVisible={toggleVisible}
    >
      <ButtonDropdownMenuItem
        text="Edit"
        onClick={() => {
          onEdit();
          toggleVisible(false);
        }}
      />
      <ButtonDropdownMenuItem
        text="To Order"
        onClick={onToOrder}
      />
      <PermissionsGate can={permissions.ADMIN_ADMIN}>
        <ButtonDropdownMenuItem
          text="Stock history"
          onClick={() => {
            onHistory();
            toggleVisible(false);
          }}
        />
      </PermissionsGate>
      <PermissionsGate can={permissions.COW_DELETE}>
        <ButtonDropdownMenuItem
          danger
          text="delete"
          onClick={() => {
            onDelete();
            toggleVisible(false);
          }}
        />
      </PermissionsGate>
    </CustomDropdownMenu>
  );
};

WarehouseActions.propTypes = {
  side: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onToOrder: PropTypes.func,
  onHistory: PropTypes.func,
};

WarehouseActions.defaultProps = {
  side: 'top',
  onEdit: undefined,
  onDelete: undefined,
  onToOrder: undefined,
  onHistory: undefined,
};

export default WarehouseActions;
